import {
  jb_language_icon_css_default
} from "./chunk.ZPWXNOZI.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Icon
} from "./chunk.IIVCI7D3.js";
import {
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/icons/jb-language-icon/jb-language-icon.ts
var JbLanguageIcon = class extends Icon(r) {
  render() {
    return ke`
      <svg
        width="20"
        height="20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.903 5.455C17.245 2.22 13.878 0 10 0 6.12 0 2.753 2.221 1.096 5.458c-.007.013-.015.025-.02.038A9.934 9.934 0 0 0 0 10c0 1.62.39 3.15 1.076 4.504.005.013.013.025.02.038C2.753 17.78 6.12 20 10 20c3.878 0 7.245-2.22 8.903-5.455.007-.014.016-.027.022-.042A9.934 9.934 0 0 0 20 10c0-1.62-.39-3.148-1.075-4.503-.006-.015-.015-.028-.022-.042zm-.666 8.458h-3.822c.212-1.071.339-2.243.362-3.478h4.331a9.051 9.051 0 0 1-.871 3.478zM10 19.13c-1.375 0-2.609-1.763-3.308-4.347h6.616c-.7 2.584-1.933 4.347-3.308 4.347zm-3.516-5.217a18.954 18.954 0 0 1-.387-3.478h7.806a19.028 19.028 0 0 1-.387 3.478H6.484zM.892 10.435h4.33c.025 1.235.15 2.407.363 3.478H1.763a9.051 9.051 0 0 1-.871-3.478zm.871-4.348h3.822a19.951 19.951 0 0 0-.362 3.478H.892a9.051 9.051 0 0 1 .871-3.478zM10 .87c1.375 0 2.609 1.763 3.308 4.347H6.692C7.392 2.633 8.625.87 10 .87zm3.516 5.217a18.95 18.95 0 0 1 .387 3.478H6.097c.026-1.233.162-2.41.387-3.478h7.032zm1.261 3.478a19.992 19.992 0 0 0-.362-3.478h3.822a9.051 9.051 0 0 1 .871 3.478h-4.33zm2.986-4.348h-3.545c-.44-1.725-1.114-3.132-1.941-4.048a9.148 9.148 0 0 1 5.486 4.048zM7.723 1.17c-.827.916-1.501 2.323-1.942 4.048H2.237A9.15 9.15 0 0 1 7.723 1.17zM2.237 14.783h3.544c.44 1.725 1.115 3.132 1.942 4.048a9.15 9.15 0 0 1-5.486-4.048zm10.04 4.048c.827-.916 1.501-2.323 1.942-4.048h3.544a9.15 9.15 0 0 1-5.486 4.048z"
          fill-rule="evenodd"
        ></path>
      </svg>
    `;
  }
};
JbLanguageIcon.styles = [reset_css_default, jb_language_icon_css_default];
JbLanguageIcon = __decorateClass([
  customElement("jb-language-icon")
], JbLanguageIcon);

export {
  JbLanguageIcon
};
